import { Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { FC } from "react";
import { wrapperIcons } from "../../swap.style";

interface IProps {
  setSwitch: (arg0: number) => void;
}

const IconsAction: FC<IProps> = ({ setSwitch }) => {
  const handleClick = () => {
    setSwitch(3);
  };

  return (
    <Grid sx={wrapperIcons}>
      {/* <IconButton>
        <img src="./assets/images/swap/wallet.svg" alt="flashift" />
      </IconButton>
      <IconButton>
        <img src="./assets/images/swap/settings.svg" alt="flashift" />
      </IconButton> */}

      <Button onClick={handleClick} variant="outlined" size="small">
        <img src="./assets/images/swap/history.svg" alt="flashift" />
        History
      </Button>
    </Grid>
  );
};
export default IconsAction;
